import { RootState } from "store";


function selectCatalogs(state: RootState) {
  return state.inventory.paginatedCatalogs;
}

export { selectCatalogs }
